import { httpLogger as log } from 'common/services/logging/loggers';
/**
 * Http Interceptor for logging REST calls into the console.
 */

const getResourceFromUrl = (url) => {

    const res = /https?:\/\/.+(\/[a-z0-9]+\/.+?)+[/|?]/.exec(url);
    return res && res[1];

};

angular.module('services')
    .factory('LogHttpRESTAPIInterceptor', ($injector, $q, $rootScope) => {

        const { url } = CWCONFIG.restApi;
        return {
            request(request) {

                if (request.url.indexOf(url) > -1) {

                    const resource = getResourceFromUrl(request.url);

                    log.info({
                        type: `API REQ ${request.method} ${resource}`,
                        data: request.data,
                    });


                }

                return request;

            },
            response(response) {

                if (response.config.url.indexOf(url) > -1) {

                    const resource = getResourceFromUrl(response.config.url);

                    // REST HTTP CALL
                    log.info({
                        type: 'API RES',
                        cmd: `${response.config.method} ${resource} ${response.status}`,
                        data: response.data,
                    });

                }

                return response;

            },
            responseError(response) {

                const ErrorHandler = $injector.get('ErrorHandler');
                const Util = $injector.get('Util');

                // token has expired, show expired token modal
                if (response.status === 401 &&
                        Util.deepFind(response, 'data.error') &&
                        response.data.error === 'expired_token') {

                    const errorLocation = 'HttpInterceptor 401 Expired Token Error';

                    ErrorHandler.handleError(response, errorLocation);

                }
                // save data error on $rootScope so it can be used in alert component
                if (response.data && response.status &&
                    (response.data.error || response.data.errors ||
                        response.data.errorCode || response.data.message)) {

                    let errorMsg = '';

                    if (response.data.error) {

                        errorMsg = response.data.error;

                    }
                    if (response.data.errors && response.data.errors.length) {

                        errorMsg = response.data.errors[0].detail;

                    }
                    if (response.data.errorCode) {

                        errorMsg = response.data.errorCode;

                    }

                    if (response.data.message) {

                        errorMsg = response.data.message;

                    }

                    $rootScope.errorMessage = `${response.status} (${errorMsg})`;

                    setTimeout(() => {

                        $rootScope.errorMessage = '';

                    }, 2000);

                }

                if (response.config) {

                    log.log({
                        type: 'API RES',
                        cmd: `ERROR ${response.status} ${response.config.method} ${getResourceFromUrl(response.config.url) || ''}`,
                        data: response.data,
                    });

                }

                if (response.status === -1) {

                    $rootScope.errorMessage = 'Connection Error (-1)';

                }

                if (window.external && ('WriteLog' in window.external)) {

                    const message = {
                        status: response.status,
                        errorMessage: $rootScope.errorMessage,
                        data: response.data,
                    };

                    window.external.WriteLog('ERROR', JSON.stringify(message));

                }

                // !!Important Must use promise api's q.reject()
                // to properly implement this interceptor
                // or the response will go the success handler of the caller
                return $q.reject(response);

            },
        };

    });



// WEBPACK FOOTER //
// ./scripts/common/services/LogHttpRESTAPIInterceptor.js